'use client';

import getImages from '@/actions/projects/getImages';
import ArrowRight from '@/assets/svg/ArrowRight';
import Slider from '@/components/ui/slider';
import { VideoPlayer } from '@/components/ui/video-player';
import { StrapiImage } from '@/types/img';
import { Project } from '@/types/project';
import { Service } from '@/types/service';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useState } from 'react';

interface Props {
  project: Project;
  locale: string;
  slug: string;
}

export default function ImagesSection({ project, locale, slug }: Props) {
  const [images, setImages] = useState<
    {
      id: number;
      indexId: number;
      img: StrapiImage;
      media: 'image' | 'video';
    }[]
  >([]);

  useEffect(() => {
    getImages({
      locale: locale,
      slug,
      baseUrl: true,
    }).then((res) => {
      if (res.data?.data) {
        let imgArr = res.data.data[0]?.images;
        !!imgArr?.length &&
          setImages(imgArr.sort((a, b) => a.indexId - b.indexId));
      }
    });
  }, [project]);

  return (
    <Slider
      centerMode={false}
      withArrows={true}
      slideNum={1}
      length={5}
      infinite={true}
      classNames='w-full'
    >
      {images.map((i) => (
        <div key={i.id} className='w-full px-2'>
          <div className='overflow-hidden rounded-[20px]'>
            {i?.media === 'video' ? (
              <VideoPlayer src={
                  typeof i.img?.url === 'string'
                    ? i.img.url
                    : (i.img?.url as { src?: string })?.src ?? ''
                } />
            ) : i?.img?.url && i?.img?.width && i?.img?.height ? (
              <Image
                src={i.img.url}
                width={i.img.width}
                height={i.img.height}
                className='w-full h-full bg-black object-cover rounded-[20px]'
                alt=''
                unoptimized
                onContextMenu={(e) => e.preventDefault()}
              />
            ) : null}
          </div>
        </div>
      ))}
    </Slider>
  );
}
